import type { IconDefinition } from '../index.tsx';

export const iconSearch: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconSearch',
  icon: [
    16,
    16,
    [],
    '',
    'M7 14C8.57234 14 10.0236 13.4816 11.1922 12.6064L14.2929 15.7071L15.7071 14.2929L12.6064 11.1922C13.4816 10.0236 14 8.57234 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7 11C9.20914 11 11 9.20914 11 7C11 4.79086 9.20914 3 7 3C4.79086 3 3 4.79086 3 7C3 9.20914 4.79086 11 7 11Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
